/** Biblioteca de equipamentos compartilhada pelo Mapa de Comando e pelo SCADA 3D. */
export const MODELOS_SANEAMENTO = {
  poco: "poco", reservatorio: "reservatorio", elevado: "reservatorio_elevado", pressao: "ponto_pressao", macro: "macromedidor",
  vrp: "vrp", motobomba: "motobomba", tecnico: "tecnico", gestor: "gestor", operador: "operador", gerente: "gerente",
} as const;
export const ESTACAO_COMANDO = "/modelos/saneamento/estacao_comando.glb";

export function arquivoScada(tipo: string, identificacao: string): string | null {
  if (["bomba", "elevatoria", "poco_profundo"].includes(tipo)) return ESTACAO_COMANDO;
  const modelo = tipo === "reservatorio" ? (/(^|[^a-z])REL[-_ ]?\d/i.test(identificacao) ? "reservatorio_elevado" : "reservatorio")
    : ({ macromedidor: "macromedidor", vrp: "vrp", ponto_pressao: "ponto_pressao" } as Record<string, string>)[tipo];
  return modelo ? `/modelos/saneamento/${modelo}.glb` : null;
}
